// Названия страниц для вкладок (TabBar). Ключ — pathname без завершающего слэша.
// /chart намеренно отсутствует — embed-страница без Layout (EXCLUDE_LAYOUT).
export const PAGE_TITLES = {
  '/': 'Главная',
  '/orders': 'Заказы',
  '/report': 'Отчёты',
  '/phrase-monitoring': 'Мониторинг фраз',
  '/seo-texts': 'SEO тексты',
  '/wb-financial': 'Еженедельный WB',
  '/product-card': 'Карточка товара',
  '/stocks-report': 'Остатки',
  '/finance-company': 'Отчёт по компании',
  '/finance-opex': 'Операционные расходы',
  '/finance-siman': 'Отчёт Siman',
  '/supplies': 'Заказ в Китай',
  '/supply-region': 'Поставка регион',
  '/supply-from-1c': 'Поставка из 1С',
  '/excel-postavki': 'Excel поставки',
  '/qr-print': 'ШК короб',
  '/fbw-slots': 'Ловец слотов FBW',
  '/marking': 'КИЗ остатки',
  '/marking/create': 'Новый заказ ЧЗ',
  '/marking/order': 'Заказ ЧЗ',
  '/marking/orders': 'Заказы ЧЗ',
  '/marking/remarking': 'Копирование КИЗ',
  '/marking/withdrawal': 'Вывод из оборота',
  '/marking/upd': 'УПД в ЭДО',
  '/kiz-qr': '31 знак QR',
  '/fbs-check': 'Проверка сборки FBS',
  '/fbs-video': 'Видео FBS',
  '/supply-qr': 'QR поставок',
  '/ai-photo': 'AI контент',
  '/photo-editor': 'Фоторедактор WB',
  '/ai-prompts': 'Промпты фотосессии',
  '/ab-tests': 'A/B тесты',
  '/ab-tests/new': 'Новый A/B тест',
  '/notifications': 'Уведомления',
  '/communication': 'Покупатели',
  '/repricer': 'Репрайсер',
  '/bidder': 'Биддер',
  '/ozon-sync': 'Ozon · Загрузка карточек',
  '/ozon-orders': 'Ozon · Заказы',
  '/ozon-supply-from-1c': 'Ozon · Поставка из 1С',
  '/ozon-slots': 'Ozon · Ловец слотов',
  '/ozon-edo': 'Ozon · ЭДО',
  '/ozon-communication': 'Ozon · Покупатели',
  '/antifraud': 'Антифрод',
  '/ozon-antifraud': 'Ozon · Антифрод',
  '/settings': 'Настройки',
  '/ozon-repricer': 'Ozon · Репрайсер',
  '/ozon-financial': 'Ozon · Еженедельный отчёт',
  '/ozon-product-card': 'Ozon · Карточка товара',
  '/ozon-fbs-check': 'Проверка сборки FBS Ozon',
  '/inout': 'Приход/Уход',
  '/attendance': 'Посещаемость',
  '/instaprazdnik': 'Инстапраздник',
  '/etiketka-a4': 'Этикетка A4',
};

// Иконки страниц для вкладок (Phosphor, набор тот же, что в меню сайдбара).
export const PAGE_ICONS = {
  '/': 'ph-house',
  '/orders': 'ph-shopping-cart-simple',
  '/report': 'ph-chart-bar',
  '/phrase-monitoring': 'ph-chart-bar',
  '/seo-texts': 'ph-chart-bar',
  '/wb-financial': 'ph-chart-bar',
  '/product-card': 'ph-chart-bar',
  '/ozon-financial': 'ph-chart-bar',
  '/ozon-product-card': 'ph-chart-bar',
  '/stocks-report': 'ph-chart-bar',
  '/finance-company': 'ph-wallet',
  '/finance-opex': 'ph-wallet',
  '/finance-siman': 'ph-wallet',
  '/supplies': 'ph-truck',
  '/supply-region': 'ph-truck',
  '/supply-from-1c': 'ph-truck',
  '/excel-postavki': 'ph-truck',
  '/qr-print': 'ph-truck',
  '/fbw-slots': 'ph-truck',
  '/marking': 'ph-qr-code',
  '/marking/create': 'ph-qr-code',
  '/marking/order': 'ph-qr-code',
  '/marking/orders': 'ph-qr-code',
  '/marking/remarking': 'ph-qr-code',
  '/marking/withdrawal': 'ph-qr-code',
  '/marking/upd': 'ph-qr-code',
  '/kiz-qr': 'ph-qr-code',
  '/fbs-check': 'ph-barcode',
  '/fbs-video': 'ph-video-camera',
  '/supply-qr': 'ph-squares-four',
  '/ai-photo': 'ph-sparkle',
  '/photo-editor': 'ph-sparkle',
  '/ai-prompts': 'ph-sparkle',
  '/ab-tests': 'ph-flask',
  '/ab-tests/new': 'ph-flask',
  '/notifications': 'ph-bell',
  '/communication': 'ph-chats-circle',
  '/repricer': 'ph-tag',
  '/ozon-repricer': 'ph-tag',
  '/ozon-orders': 'ph-shopping-cart-simple',
  '/ozon-supply-from-1c': 'ph-truck',
  '/ozon-slots': 'ph-calendar-check',
  '/ozon-edo': 'ph-file-text',
  '/ozon-communication': 'ph-chats-circle',
  '/antifraud': 'ph-shield-warning',
  '/ozon-antifraud': 'ph-shield-warning',
  '/settings': 'ph-gear',
  '/ozon-fbs-check': 'ph-barcode',
  '/bidder': 'ph-gauge',
  '/ozon-sync': 'ph-upload-simple',
  '/inout': 'ph-squares-four',
  '/attendance': 'ph-calendar-check',
  '/instaprazdnik': 'ph-squares-four',
  '/etiketka-a4': 'ph-squares-four',
};

// Gatsby 5 по умолчанию добавляет завершающий слэш (trailingSlash: 'always'),
// поэтому идентичность вкладки считаем по нормализованному пути.
export const normalizePath = (p) => {
  if (!p) return '/';
  return p !== '/' && p.endsWith('/') ? p.slice(0, -1) : p;
};

export const getPageTitle = (path) => {
  const norm = normalizePath(path);
  return PAGE_TITLES[norm] || norm.split('/').filter(Boolean).pop() || 'Страница';
};

export const getPageIcon = (path) => PAGE_ICONS[normalizePath(path)] || 'ph-file';
